import { useAnimatedBorder } from '@/hooks/useAnimationBorder';
import { useGeneratorFilterStore } from '@/state/generator-filter-store';
import useGeneratorStore, { GeneratorTypeEnums } from '@/state/generator-store';
import { getInitials } from '@/utils';
import React, { useEffect, useRef } from 'react';
import { useController } from 'react-hook-form';
import { SfHighIcon, SfLowIcon } from '../../NewStyleFilter/StyleFilterList';
import { useStyleFilterFromParams } from '../../../hooks/useStyleFilterFromParams';

interface AddFilterIconProps {
  className?: string;
  onClick: () => void;
}

const AddFilterIcon: React.FC<AddFilterIconProps> = ({ ...props }) => {
  const sfIconContainer = useRef<HTMLDivElement>(null);

  const { currentFilterGroup, currentFilterGroups, disabled } = useGeneratorFilterStore();
  const mainSFGroup = currentFilterGroups?.[0];
  const secondarySFGroup = currentFilterGroups?.[1];

  const { start, stop } = useAnimatedBorder(sfIconContainer, {});

  useStyleFilterFromParams();

  useEffect(() => {
    start();
  }, []);

  const { control, generatorType } = useGeneratorStore((state) => ({
    control: state.control,
    generatorType: state.generatorType,
  }));

  const {
    field: { value: filterWeight },
  } = useController({
    name: 'filterWeight',
    control,
  });

  if (generatorType === GeneratorTypeEnums.R3IMAGINE) {
    return null;
  }

  const buttonDisabled = disabled || generatorType === GeneratorTypeEnums.EDITOR;

  return (
    <div
      className={`flex gap-[4px] h-full items-center transition-opacity ${props.className} ${buttonDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-80'}`}
      onClick={() => {
        if (buttonDisabled) return;
        stop();
        props.onClick();
      }}
    >
      <div
        style={{
          writingMode: 'vertical-rl',
          transform: 'rotate(180deg)',
        }}
        className="text-center text-[#676767] text-[10px] leading-[13px] tracking-[0.2px] font-pressura-mono"
      >
        FILTERS
      </div>
      {/* <div className="relative rounded-md" ref={sfIconContainer}>
        <div>
          <SfBg></SfBg>
          <NewTag className="absolute left-[5px] top-[8px]" />
          <AddTag className="absolute left-[12px] top-[40px]" />
          {!!currentFilterGroup && (
            <div className="rounded-md absolute left-[4px] top-[4px] w-[46px] h-[72px]" ref={sfIconContainer}>
              {(currentFilterGroup?.thumb_album_cover ?? currentFilterGroup?.album_cover) ? (
                <img
                  src={currentFilterGroup?.thumb_album_cover ?? currentFilterGroup?.album_cover}
                  className={'absolute left-0 top-0 block w-full h-full rounded object-cover bg-cover flex-shrink-0 bg-neutral-800'}
                />
              ) : (
                <div className="absolute left-0 top-0 block w-full h-full text-center rounded object-cover bg-cover flex-shrink-0 bg-jen-orange">
                  {currentFilterGroup?.artist && (
                    <div className="absolute bottom-[26px] w-full">
                      <span className="text-[22px] uppercase text-white">{getInitials(currentFilterGroup.artist)}</span>
                    </div>
                  )}
                </div>
              )}

              {filterWeight === 1 ? (
                <SfHighIcon className="w-[34px] h-[34px] absolute left-[6px] bottom-[-4px]" />
              ) : (
                <SfLowIcon className="w-[34px] h-[34px] absolute left-[6px] bottom-[-4px]" />
              )}
            </div>
          )}
        </div>
      </div> */}

      <div className="relative">
        <DarkCard size={currentFilterGroups.length > 1 ? 'medium' : 'small'}>
          <NewTag className="absolute left-[10px] top-[8px]" />
          <AddTag className="absolute left-[15px] top-[42px]" />
          {secondarySFGroup && (
            <div className="rounded-md absolute left-[44px] top-[12px] w-12 h-[66px]" ref={sfIconContainer}>
              {(secondarySFGroup?.thumb_album_cover ?? secondarySFGroup?.album_cover) ? (
                <img
                  src={secondarySFGroup?.thumb_album_cover ?? secondarySFGroup?.album_cover}
                  className={'absolute left-0 top-0 block w-full h-full rounded object-cover bg-cover flex-shrink-0 bg-neutral-800'}
                />
              ) : (
                <div className="absolute left-0 top-0 block w-full h-full text-center rounded object-cover bg-cover flex-shrink-0 bg-jen-orange">
                  {secondarySFGroup?.artist && (
                    <div className="absolute bottom-[18px] w-full">
                      <span className="text-[22px] uppercase text-white">{getInitials(secondarySFGroup.artist)}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {!!mainSFGroup && (
            <div className="rounded-md absolute left-[4px] top-[4px] w-14 h-[86px]" ref={sfIconContainer}>
              {(mainSFGroup?.thumb_album_cover ?? mainSFGroup?.album_cover) ? (
                <img
                  src={mainSFGroup?.thumb_album_cover ?? mainSFGroup?.album_cover}
                  className={'absolute left-0 top-0 block w-full h-full rounded object-cover bg-cover flex-shrink-0 bg-neutral-800'}
                />
              ) : (
                <div className="absolute left-0 top-0 block w-full h-full text-center rounded object-cover bg-cover flex-shrink-0 bg-jen-orange">
                  {mainSFGroup?.artist && (
                    <div className="absolute bottom-[26px] w-full">
                      <span className="text-[22px] uppercase text-white">{getInitials(mainSFGroup.artist)}</span>
                    </div>
                  )}
                </div>
              )}

              {/* {filterWeight === 1 ? (
                <SfHighIcon className="w-[34px] h-[34px] absolute left-[6px] bottom-[-4px]" />
              ) : (
                <SfLowIcon className="w-[34px] h-[34px] absolute left-[6px] bottom-[-4px]" />
              )} */}
            </div>
          )}
        </DarkCard>
      </div>
    </div>
  );
};

const DarkCard = ({ size = 'small', children }: { size?: 'small' | 'medium'; children: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-center rounded bg-[#1a1a1a]">
      <div
        className={`${size === 'small' ? 'w-16' : 'w-24'} h-24 rounded bg-gradient-to-b from-[#1e1e1e] to-[#121212] shadow-inner border border-[#2a2a2a]`}
      >
        {children}
      </div>
    </div>
  );
};

const SfBg = ({ ...props }) => {
  return (
    <svg {...props} width="54" height="80" viewBox="0 0 54 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_iiii_359_1321)">
        <rect width="54" height="80" rx="6" fill="url(#paint0_linear_359_1321)" />
      </g>
      <rect x="0.5" y="0.5" width="53" height="79" rx="5.5" stroke="url(#paint1_linear_359_1321)" />
      <defs>
        <filter
          id="filter0_iiii_359_1321"
          x="0"
          y="0"
          width="63"
          height="94"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_359_1321" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="2" dy="9" />
          <feGaussianBlur stdDeviation="4.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_innerShadow_359_1321" result="effect2_innerShadow_359_1321" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="5" dy="20" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect2_innerShadow_359_1321" result="effect3_innerShadow_359_1321" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="9" dy="35" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect3_innerShadow_359_1321" result="effect4_innerShadow_359_1321" />
        </filter>
        <linearGradient id="paint0_linear_359_1321" x1="27" y1="80" x2="27" y2="2.26824e-08" gradientUnits="userSpaceOnUse">
          <stop stop-color="#191A1B" />
          <stop offset="1" stop-color="#1E2021" />
        </linearGradient>
        <linearGradient id="paint1_linear_359_1321" x1="27" y1="-1.94973e-07" x2="13.1217" y2="61.4765" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="white" stop-opacity="0.15" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const NewTag = ({ ...props }) => {
  return (
    <svg {...props} width="45" height="20" viewBox="0 0 45 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_ddd_359_1326)">
        <rect x="4" y="1" width="36" height="12" rx="6" fill="url(#paint0_linear_359_1326)" shape-rendering="crispEdges" />
        <rect
          x="4.5"
          y="1.5"
          width="35"
          height="11"
          rx="5.5"
          stroke="url(#paint1_linear_359_1326)"
          stroke-opacity="0.5"
          shape-rendering="crispEdges"
        />
        <g filter="url(#filter1_d_359_1326)">
          <rect x="8" y="5" width="4" height="4" rx="2" fill="#FF5B27" />
        </g>
        <path
          d="M21.4102 3.45898H22.2598C22.2923 3.45898 22.3086 3.47526 22.3086 3.50781V10.4512C22.3086 10.4837 22.2923 10.5 22.2598 10.5H20.79C20.7575 10.5 20.7314 10.4837 20.7119 10.4512L17.6797 4.44043C17.6634 4.40788 17.6439 4.39811 17.6211 4.41113C17.5951 4.42415 17.582 4.44043 17.582 4.45996V10.4512C17.582 10.4837 17.5641 10.5 17.5283 10.5H16.6787C16.6462 10.5 16.6299 10.4837 16.6299 10.4512V3.50781C16.6299 3.47526 16.6462 3.45898 16.6787 3.45898H18.1582C18.1842 3.45898 18.2087 3.47526 18.2314 3.50781L21.2588 9.50879C21.2751 9.53483 21.2962 9.54785 21.3223 9.54785C21.3483 9.54785 21.3613 9.53158 21.3613 9.49902V3.50781C21.3613 3.47526 21.3776 3.45898 21.4102 3.45898ZM26.8891 7.51172C26.8891 7.17969 26.7702 6.87533 26.5326 6.59863C26.2917 6.3252 25.9483 6.18848 25.5023 6.18848C25.0564 6.18848 24.7064 6.33659 24.4525 6.63281C24.1986 6.92904 24.0717 7.22201 24.0717 7.51172C24.0717 7.54427 24.088 7.56055 24.1205 7.56055H26.8402C26.8728 7.56055 26.8891 7.54427 26.8891 7.51172ZM27.9291 7.9707C27.9291 8.19531 27.9031 8.30762 27.851 8.30762H24.1205C24.088 8.30762 24.0717 8.32552 24.0717 8.36133C24.0717 8.73893 24.2019 9.06445 24.4623 9.33789C24.7227 9.61133 25.0661 9.74805 25.4926 9.74805C26.0915 9.74805 26.5147 9.5153 26.7621 9.0498C26.7751 9.01725 26.7979 9.00098 26.8305 9.00098H27.7191C27.7582 9.00098 27.7761 9.01725 27.7729 9.0498C27.6459 9.53809 27.3773 9.91895 26.9672 10.1924C26.557 10.4658 26.0655 10.6009 25.4926 10.5977C24.7536 10.5977 24.1628 10.3568 23.7201 9.875C23.2807 9.39323 23.0609 8.75521 23.0609 7.96094C23.0609 7.16667 23.2758 6.5319 23.7055 6.05664C24.1352 5.58138 24.7325 5.34375 25.4975 5.34375C26.2624 5.34375 26.8598 5.58138 27.2895 6.05664C27.7191 6.53841 27.9324 7.17643 27.9291 7.9707ZM34.1697 10.5H32.9002C32.8807 10.5 32.8644 10.4837 32.8514 10.4512L31.8797 6.46191C31.8732 6.43262 31.8569 6.41797 31.8309 6.41797C31.8048 6.41797 31.7869 6.43262 31.7771 6.46191L30.8201 10.4512C30.8071 10.4837 30.7908 10.5 30.7713 10.5H29.5018C29.4757 10.5 29.4546 10.4837 29.4383 10.4512L28.2518 5.49023C28.2452 5.45768 28.2648 5.44141 28.3104 5.44141H29.16C29.1795 5.44141 29.1958 5.45768 29.2088 5.49023L30.0779 9.50879C30.0877 9.53483 30.1056 9.54785 30.1316 9.54785C30.1577 9.54785 30.174 9.53483 30.1805 9.50879L31.1717 5.49023C31.1847 5.45768 31.201 5.44141 31.2205 5.44141H32.451C32.4705 5.44141 32.4868 5.45768 32.4998 5.49023L33.491 9.50879C33.4975 9.53483 33.5138 9.54785 33.5398 9.54785C33.5659 9.54785 33.5822 9.53483 33.5887 9.50879L34.4578 5.49023C34.4708 5.45768 34.4887 5.44141 34.5115 5.44141H35.3611C35.4067 5.44141 35.4262 5.45768 35.4197 5.49023L34.2283 10.4512C34.2153 10.4837 34.1958 10.5 34.1697 10.5Z"
          fill="#FF5B27"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd_359_1326"
          x="0.538775"
          y="0.0110784"
          width="43.9114"
          height="19.9114"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="0.494461" dy="2.96676" />
          <feGaussianBlur stdDeviation="1.97784" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_359_1326" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="1.97784" dy="1.97784" />
          <feGaussianBlur stdDeviation="1.23615" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_359_1326" result="effect2_dropShadow_359_1326" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.24723" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.31751 0 0 0 0 0.329873 0 0 0 0 0.342236 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_359_1326" result="effect3_dropShadow_359_1326" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_359_1326" result="shape" />
        </filter>
        <filter id="filter1_d_359_1326" x="4" y="1" width="12" height="12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.357167 0 0 0 0 0.154167 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_359_1326" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_359_1326" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_359_1326" x1="6.47059" y1="4.05882" x2="15.4947" y2="21.7958" gradientUnits="userSpaceOnUse">
          <stop stop-color="#383A3C" />
          <stop offset="1" stop-color="#2C2F30" />
        </linearGradient>
        <linearGradient id="paint1_linear_359_1326" x1="22" y1="1" x2="24.5075" y2="12.0729" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0.15" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const AddTag = ({ ...props }) => {
  return (
    <svg {...props} width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_ddd_359_1322)">
        <circle cx="16" cy="13" r="12" fill="url(#paint0_linear_359_1322)" />
        <circle cx="16" cy="13" r="11.5" stroke="url(#paint1_linear_359_1322)" stroke-opacity="0.5" />
      </g>
      <path
        d="M15.4 13.48V13.6H15.52L15.52 16H16.6L16.6 13.6L19 13.6V12.52L16.6 12.52V12.4H16.48L16.48 10H15.4L15.4 12.4L13 12.4V13.48L15.4 13.48Z"
        fill="#9D9DA6"
      />
      <defs>
        <filter
          id="filter0_ddd_359_1322"
          x="0.538775"
          y="0.0110784"
          width="31.9114"
          height="31.9114"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="0.494461" dy="2.96676" />
          <feGaussianBlur stdDeviation="1.97784" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_359_1322" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="1.97784" dy="1.97784" />
          <feGaussianBlur stdDeviation="1.23615" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_359_1322" result="effect2_dropShadow_359_1322" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="0.24723" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.31751 0 0 0 0 0.329873 0 0 0 0 0.342236 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_359_1322" result="effect3_dropShadow_359_1322" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_359_1322" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_359_1322" x1="5.64706" y1="7.11765" x2="26.1176" y2="20.5294" gradientUnits="userSpaceOnUse">
          <stop stop-color="#383A3C" />
          <stop offset="1" stop-color="#2C2F30" />
        </linearGradient>
        <linearGradient id="paint1_linear_359_1322" x1="16" y1="0.999999" x2="26.8219" y2="16.9294" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0.15" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { AddFilterIcon };
